import { useCheckAuthQuery } from "store/auth/auth.api";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { setCredentials, logoutUser } from "store/slices/auth.slice";

export function useCheckAuth() {
  const dispatch = useDispatch();

  const { data, error, isLoading, isSuccess } = useCheckAuthQuery();

  useEffect(() => {
    if (isSuccess && data?.payload?.user) {
      dispatch(
        setCredentials({
          user: data.payload.user,
          token: null, // token is stored in cookie, no need to save in Redux
        })
      );
    }

    if (error?.status === 401) {
      dispatch(logoutUser());
    }
  }, [data, error, dispatch, isSuccess]);

  return { isLoading, isAuthenticated: !!data?.payload?.user };
}
